// Models
import { EventActionTypes } from 'app/shared/eventsOld/models';

export const selectEvaluationLog = (state: RootState) => {
  return state.sliceEvents.evaluationLog;
};

// Loading
export const selectEditEventLoading = (state: RootState) =>
  Boolean(state.loading[EventActionTypes.EDIT_EVENT]);
